import React from 'react';
import PropTypes from 'prop-types';
import Trade from './Trade';
import DateRow from './DateRow';

const datesAreOnSameDay = (first, second) => {
  first = new Date(first);
  second = new Date(second);
  return (
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate()
  );
};

function TradesWithDates({ trades, market }) {
  const history = [];
  for (let i = 0; i < trades.length; i++) {
    const prev = trades[i - 1];
    const curr = trades[i];
    const today = new Date();

    if (!prev && !datesAreOnSameDay(curr.createdAt, today)) {
      const date = new Date(curr.createdAt);
      history.push(<DateRow date={date} key={date} />);
    } else if (prev && !datesAreOnSameDay(prev.createdAt, curr.createdAt)) {
      const date = new Date(curr.createdAt);
      history.push(<DateRow date={date} key={date} />);
    }

    history.push(
      <Trade
        market={market}
        item={curr}
        key={`${curr.price}-${curr.quantity}-${curr.createdAt}-${curr.makerOrder.side}`}
      />
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{history}</>;
}

TradesWithDates.propTypes = {
  trades: PropTypes.array.isRequired,
  market: PropTypes.object
};

TradesWithDates.defaultProps = {
  market: null
};

export default TradesWithDates;
